<template>
  <messages-list
    :customerID="customerID"
    :requestWhere="requestWhere"
    :routePath="'lista-wiadomosci'"/>
</template>

<script>
import MessagesList from '@/views/lists/MessagesList.vue';

export default {
  name: 'customer-messages-wrapper',
  components: {
    'messages-list': MessagesList
  },
  props: {
    customerID: {
      type: Number,
      required: true
    },
    requestWhere: {
      type: Object
    },
  }
}
</script>
